// extracted by mini-css-extract-plugin
module.exports = {"title":"CompanyEditForm_title__2KEqE","divider":"CompanyEditForm_divider__GseJO"};